import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import { FaTwitter, FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    { Social: <FaFacebookF />, link: 'https://www.facebook.com/massDevelop' },
    { Social: <FaLinkedinIn />, link: 'https://www.linkedin.com/company/mass-dev/' },
    { Social: <FaInstagram />, link: 'https://www.instagram.com/mass.develop/' },
    // { Social: <FaTwitter />, link: 'https://twitter.com/' },
]

class PortfolioDetails extends Component {
    constructor() {
        super()
        this.state = {
            isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal() {
        this.setState({ isOpen: true })
    }
    render() {
        return (
            <React.Fragment>
                <PageHelmet pageTitle='Freemium Details' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--2" data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">MassDev Freemuims</h2>
                                    <p> Empowering the New Generation in Arab World with Modern High-Tech UX and Web Development </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>Introduction</h2>
                                        <p className="subtitle">In today's rapidly evolving digital landscape, staying ahead of the curve is essential for businesses and individuals alike.</p>
                                        <p>MassDev, a groundbreaking company, is revolutionizing the Arab world by introducing Freemuims - a powerful fusion of Free and Premium offerings that aims to empower the new generation with modern high-tech UX and web development solutions. With a commitment to excellence and innovation, MassDev is setting the stage for the next era of digital transformation in the Arab world, inspiring young minds to chase new features and embrace the cutting-edge in technology.
                                        </p>
{/*                                        
                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Branch</span>
                                                <h4>Ability</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Project Types</span>
                                                <h4>Website</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Program</span>
                                                <h4>View Project</h4>
                                            </div>
                                        </div> */}

                                        <div className="portfolio-share-link mt--20 pb--70 pb_sm--40">
                                            <ul className="social-share rn-lg-size d-flex justify-content-start liststyle mt--15">
                                                {SocialShare.map((val, i) => (
                                                    <li key={i}><a href={`${val.link}`} target='_blank'>{val.Social}</a></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="portfolio-thumb-inner">
                                        <div className="thumb position-relative mb--30">
                                            <img src="/assets/images/portfolio/portfolio-big-03.jpg" alt="Portfolio Images" />
                                            <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='EsTGYaRucTg' onClose={() => this.setState({ isOpen: false })} />
                                            <button className="video-popup position-top-center" onClick={this.openModal}><span className="play-icon"></span></button>
                                        </div>
                                        <div className="blog-single-list-wrapper d-flex flex-wrap">
                                            <div className="content pt-3 mb-5">
                                                <h4 className="title">Bridging the Gap with Freemuims:</h4>
                                                <ul className="list-style">
                                                    <p>
                                                        MassDev's Freemuims approach is a game-changer, enabling accessibility to state-of-the-art UX and web development tools for everyone. By offering a mix of free and premium features, the company breaks down barriers that previously limited access to advanced technologies. This innovative strategy empowers budding entrepreneurs, startups, and tech enthusiasts in the Arab world to unleash their creativity and drive impactful digital experiences.
                                                    </p>
                                                </ul>
                                                <h4 className="title">Pioneering User Experience in the Arab World:</h4>
                                                <ul className="list-style">
                                                    <p>User experience lies at the core of MassDev's philosophy, and with Freemuims, they aim to revolutionize the way Arab users interact with technology. The skilled team of UX designers at MassDev puts special emphasis on understanding the unique cultural and linguistic aspects of the Arab world. By crafting intuitive interfaces and experiences that resonate with the Arab audience, MassDev sets a new standard for user-centric design, ensuring seamless and engaging interactions with their products.</p>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="thumb mb--30">
                                            <img src="/assets/images/freemuims/1.jpg" alt="Portfolio Images" />
                                        </div>
                                        <div className="blog-single-list-wrapper d-flex flex-wrap">
                                            <div className="content pt-3 mb-5">
                                              
                                                <h4 className="title">Modern Web Development at Your Fingertips:</h4>
                                                <ul className="list-style">
                                                    <p>The world of web development is constantly evolving, and MassDev Freemuims keeps the Arab youth at the forefront of these advancements. The platform equips developers with the latest tools and technologies, including JavaScript frameworks like React, Vue, and Next.js. Whether it's front-end or back-end development, MassDev empowers the new generation with cutting-edge knowledge and skills needed to build responsive, performant, and feature-rich web applications.</p>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="thumb">
                                            <img src="/assets/images/freemuims/2.jpg" alt="Portfolio Images" />
                                        </div>
                                        <div className="blog-single-list-wrapper d-flex flex-wrap">
                                            <div className="content pt-3">
                                                <h4 className="title">Impacting the New Generation:</h4>
                                                <ul className="list-style">
                                                    <p>The impact of MassDev Freemuims extends far beyond just providing tools and resources. By democratizing access to modern high-tech UX and web development, MassDev is nurturing a new generation of tech-savvy individuals who can drive innovation and shape the future of the Arab world. With the power of Freemuims, the barriers to entry are lowered, allowing young talent to pursue their passions and participate in the digital revolution actively.</p>
                                                </ul>
                                                <h4 className="title">Fueling Innovation and Entrepreneurship:</h4>
                                                <ul className="list-style">
                                                    <p>Freemuims isn't just about learning; it's also about enabling ambitious entrepreneurs and startups. MassDev empowers individuals with the skills to turn their ideas into reality, fostering a culture of innovation and entrepreneurship in the Arab world. Armed with cutting-edge tools and guidance from experts at MassDev, aspiring startups can build scalable, innovative, and market-ready products that disrupt industries and drive economic growth.</p>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                                <div className="inner ">
                                        <h2 >Simply</h2>
                                        <p className="">MassDev Freemuims is a groundbreaking initiative that is changing the game for the new generation in the Arab world. </p>
                                        <p>By offering access to modern high-tech UX and web development resources, MassDev is inspiring young minds to chase new features, embrace innovation, and take the Arab world to new heights in the digital era. As more young talents embrace Freemuims and unleash their creative potential, the future of the Arab world's technology landscape looks brighter than ever before.</p>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Related Work */}
                {/* <div className="portfolio-related-work pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <span className="theme-color font--18 fontWeight600">Related Work</span>
                                    <h2>Our More Projects</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--10">
                            <div className="col-lg-6 col-md-6 col-12">
                                <div className="related-work text-center mt--30">
                                    <div className="thumb">
                                        <a href="/portfolio-details">
                                            <img src="/assets/images/portfolio/related-image-01.jpg" alt="Portfolio-images" />
                                        </a>
                                    </div>
                                    <div className="inner">
                                        <h4><a href="/portfolio-details">Digital Analysis</a></h4>
                                        <span className="category">Technique</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-12">
                                <div className="related-work text-center mt--30">
                                    <div className="thumb">
                                        <a href="/portfolio-details">
                                            <img src="/assets/images/portfolio/related-image-02.jpg" alt="Portfolio-images" />
                                        </a>
                                    </div>
                                    <div className="inner">
                                        <h4><a href="/portfolio-details">Plan Management</a></h4>
                                        <span className="category">PLANNING</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Related Work */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />


            </React.Fragment>
        )
    }
}
export default PortfolioDetails;
